module.exports = __webpack_public_path__ + "img/71.6af8bdc1.jpg";